import { IColumnData } from '@/editor/data/model/model';
import { ColumnEntity } from '@/editor/entities/columnEntity';
import { globalStores } from '@/editor/stores';
import { EEntityType } from '@/editor/types';

export class StructManager {
  private _list: ColumnEntity[];
  // 柱子
  private _columnVirtualEntity: ColumnEntity | null = null;

  constructor() {
    this._list = [];
  }

  get entities() {
    return this._list;
  }

  get columnVirtualEntity() {
    return this._columnVirtualEntity;
  }

  private getDataList() {
    const columnHiddenIds = globalStores.visibilityStore.getHiddenEntitiesIdsByEntityType(EEntityType.Column);
    return globalStores.structStore.getColumnDatas().filter((data) => !columnHiddenIds.has(data.id));
  }

  getColumnEntity(id: string) {
    const columnEntity = this._list.find((dw) => dw.id === id);

    return columnEntity;
  }

  updateVirtualColumn(columnData: IColumnData) {
    if (!this._columnVirtualEntity) {
      this._columnVirtualEntity = new ColumnEntity(columnData);
    }

    this._columnVirtualEntity.update(columnData);
  }

  disposeVirtualColumn() {
    if (this._columnVirtualEntity) {
      this._columnVirtualEntity.dispose();
      this._columnVirtualEntity = null;
    }
  }

  addEntity(columnEntity: ColumnEntity) {
    this._list.push(columnEntity);
  }

  updateEntity(data: { id: string }) {
    const columnData = globalStores.structStore.getColumnData(data.id);
    if (!columnData) return;

    const index = this._list.findIndex((entity) => entity.id === data.id);
    if (index === -1) {
      const newEntity = new ColumnEntity(columnData);
      newEntity.update(columnData);
      this.addEntity(newEntity);
    } else {
      this._list[index].update(columnData);
    }
  }

  update() {
    const columnDatas = this.getDataList();
    const newColumnDataMap = new Map(columnDatas.map((data) => [data.id, data]));

    for (let i = this._list.length - 1; i >= 0; i--) {
      const entity = this._list[i];
      const newColumnData = newColumnDataMap.get(entity.id);
      if (newColumnData) {
        entity.update(newColumnData);
      } else {
        this.deleteEntity(i);
      }

      newColumnDataMap.delete(entity.id);
    }

    for (const columnData of newColumnDataMap.values()) {
      const columnEntity = new ColumnEntity(columnData);
      columnEntity.update(columnData);
      this.addEntity(columnEntity);
    }
  }

  deleteEntity(index: number) {
    if (index >= this._list.length || index < 0) return;
    this._list[index].dispose();
    this._list.splice(index, 1);
  }

  updateVisible(_v: boolean, _ids: string[]) {}
}
